import React, { CSSProperties } from 'react'
import { useInitialCofig } from '../hooks/initialConfig-hook';

//AVCDAAV.002  20/03/2025  Add code for Adding bottom component

type Props = {
    name: string | React.ReactNode;
    btn_type: "confirm" | "cancel" | "default";
    type?: "button" | "submit" | "reset";
    styles?: CSSProperties;
    onClick?: () => void;
    className?: string;
    disable?: boolean;
}

export const Button = (props: Props) => {
    const { initialConfig } = useInitialCofig();
    return (
        <button type='submit' style={{...(props.btn_type === 'confirm'? 
                initialConfig.styles.confirm_button_style : 
                props.btn_type === "cancel" ? 
                initialConfig.styles.cancel_button_style : 
                initialConfig.styles.general_button_style), 
                ...props.styles} 
                } className={`btnmember btn fw-bolder px-6 py-3 ${props.className ?? ""}`}
                onClick={props.onClick}
                disabled={props.disable}
        >
            {props.name}
        </button>
    )
}


//C-AVCDAAV.002  20/03/2025  Add code for Adding bottom component